import { incomeLabel } from "@/utils/incomeTypes";
import { setIcons } from "@/utils/common";
import type { MenuProps } from "antd";
import { Button, Dropdown, Space, Switch, Tag } from "antd";
import { decimalReg } from "@/utils/regs";

export const flowingShareholders_options = [
  {
    label: "是",
    value: '1',
  },
  {
    label: "否",
    value: '0',
  },
];
export function columns(props: any) {
  const {
    providers_level,
    accountTypes,
    setOpen,
    setModalFormData,
    editPrice,
    outDetail,
    authDetail,
    changeSubsidy,
    setuserOutOpen,
    setUserOutFormData,
    userOutFormData,
    linkDetail,
    teamPerformanceDetail,
    canCloseAccount,
    handleCloseAccount,
  } = props;
  return [
    {
      title: "用户ID",

      dataIndex: "userBusinessId",
      key: "userBusinessId",
    },
    {
      title: "用户头像",
      dataIndex: "avatar",
      key: "avatar",
      render: (data: string) =>
        data && <img style={{ height: "32px" }} src={data} alt="" />,
    },
    {
      title: "昵称",
      dataIndex: "nickName",
      key: "nickName",
    },
    {
      title: "账号",
      dataIndex: "mobile",
      key: "mobile",
    },
    {
      title: "注册方式",
      dataIndex: "userRegType",
      key: "userRegType",
      render: (val: number | string) => (
        <Tag color={val == 0 ? "blue" : "green"}>
          {val == 0 ? "手机号注册" : "邮箱注册"}
        </Tag>
      ),
    },
    {
      title: incomeLabel(accountTypes, 1),
      dataIndex: "amount",
      key: "amount",
    },
    {
      title: incomeLabel(accountTypes, 3),
      dataIndex: "transferAmount",
      key: "transferAmount",
    },
    {
      title: incomeLabel(accountTypes, 4),
      dataIndex: "chargingAmount",
      key: "chargingAmount",
    },
    {
      title: `${incomeLabel(accountTypes, 4)}（冻结）`,
      dataIndex: "monthFreezeChargingAmount",
      key: "monthFreezeChargingAmount",
    },
    {
      title: incomeLabel(accountTypes, 5),
      dataIndex: "merchantAmount",
      key: "merchantAmount",
    },
    {
      title: incomeLabel(accountTypes, 7),
      dataIndex: "channelAmount",
      key: "channelAmount",
    },
    {
      title: incomeLabel(accountTypes, 2),
      dataIndex: "integral",
      key: "integral",
      render: (value?: number | null): number | string => value ?? "-",
    },
    {
      title: `冻结${incomeLabel(accountTypes, 2)}`,
      dataIndex: "freezeIntegral",
      key: "freezeIntegral",
      render: (value?: number | null): number | string => value ?? "-",
    },
    {
      title: "当月全链总业绩",
      dataIndex: "monthTeamUserOrderAmount",
      key: "monthTeamUserOrderAmount",
    },
    {
      title: "当月直推业绩",
      dataIndex: "monthDirectTeamUserOrderAmount",
      key: "monthDirectTeamUserOrderAmount",
    },
    {
      title: "个性签名",
      dataIndex: "personalizedSignature",
      key: "personalizedSignature",
    },
    {
      title: "推荐人Id",
      dataIndex: "recommendUserId",
      key: "recommendUserId",
    },
    {
      title: "团队属性",
      dataIndex: "teamAttribute",
      key: "teamAttribute",
    },
    // {
    //   title: "分佣类型",
    //   dataIndex: "deviceFlowRewardType",
    //   key: "deviceFlowRewardType",
    //   render: (val: number) => (
    //     <Tag color="blue">
    //       {val === 0 ? "通用模式" : val === 1 ? "自定义模式" : "不分佣"}
    //     </Tag>
    //   ),
    // },
    // {
    //   title: "佣金最大值",
    //   dataIndex: "deviceFlowRewardMax",
    //   key: "deviceFlowRewardMax",
    // },
    // {
    //   title: "佣金最小值",
    //   dataIndex: "deviceFlowRewardMin",
    //   key: "deviceFlowRewardMin",
    // },
    {
      title: "收货地址",
      dataIndex: "address",
      key: "address",
      render: (val: string, rows: any) => (
        <div>{rows.provinceName + rows.cityName + rows.districtName || ""}</div>
      ),
    },
    {
      title: "创建时间",
      dataIndex: "createTime",
      key: "createTime",
      // render: (val: string) => <div>{getTimeFormat(val)}</div>
    },
    {
      title: "用户等级",
      dataIndex: "userLevel",
      key: "userLevel",
      render: (val: string) => (
        <Tag color="blue">
          {
            providers_level?.find((i: { value: string }) => i.value === val)
              ?.label
          }
        </Tag>
      ),
    },
    {
      title: "用户类型",
      dataIndex: "userType",
      key: "userType",
      render: (val: string) => (
        <Tag color="blue">{val === "0" ? "管理" : "普通"}</Tag>
      ),
    },
    {
      title: "补贴",
      dataIndex: "skipBuTie",
      key: "skipBuTie",
      render: (val: number, rows: any) => (
        <Switch onChange={(e) => changeSubsidy(rows)} checked={val === 1} />
      ),
    },
      {
        title: "流水股东",
        dataIndex: "flowingShareholders",
        key: "flowingShareholders",
        render: (val: string, rows: any) => (
          flowingShareholders_options.find((i: { value: string }) => i.value === val)
            ?.label
        ),
      },

    {
      title: "操作",
      dataIndex: "userId",
      key: "userId",
      fixed: "right",
      render: (val: string, rows: any) => {
        const moreItems: MenuProps["items"] = [];
        if (rows.userStatus === "0") {
          moreItems.push(
            {
              key: "edit",
              label: "修改",
              onClick: () => outDetail(val),
            },
            {
              key: "team",
              label: "团队业绩",
              onClick: () => teamPerformanceDetail(rows),
            },
            {
              key: "link",
              label: "链路详情",
              onClick: () => linkDetail(val),
            },
            {
              key: "auth",
              label: "团队属性",
              onClick: () => authDetail(rows),
            }
          );
        }
        moreItems.push({
          key: "referrer",
          label: "推荐人变更",
          onClick: () => {
            setuserOutOpen(true);
            setUserOutFormData({
              ...userOutFormData,
              userId: val,
            });
          },
        });
        if (canCloseAccount && rows.delFlag === "0") {
          moreItems.push({
            key: "closeAccount",
            label: "注销用户",
            danger: true,
            onClick: () => handleCloseAccount(val, rows.mobile),
          });
        }

        return (
          <Space size="small">
            {rows.userStatus === "0" ? (
              <Button
                size="small"
                type="link"
                onClick={() => {
                  setOpen(true);
                  setModalFormData({
                    userId: val,
                  });
                }}
              >
                添加金额
              </Button>
            ) : null}
            <Dropdown menu={{ items: moreItems }} trigger={["click"]}>
              <Button size="small" type="link">
                更多 {setIcons("DownOutlined")}
              </Button>
            </Dropdown>
          </Space>
        );
      },
    },
  ];
}

export const linkColumns = [
  {
    title: "用户ID",
    dataIndex: "userId",
    key: "userId",
  },
  {
    title: "昵称",
    dataIndex: "nickName",
    key: "nickName",
  },
  {
    title: "手机号",
    dataIndex: "mobile",
    key: "mobile",
  },
  // {
  //   title: "关系路径",
  //   dataIndex: "recommenderPath",
  //   key: "recommenderPath",
  // },
  {
    title: "推荐者Id",
    dataIndex: "recommendUserId",
    key: "recommendUserId",
  },
  {
    title: "用户等级",
    dataIndex: "userLevel",
    key: "userLevel",
  },
  {
    title: "备注",
    dataIndex: "remark",
    key: "remark",
  },
  {
    title: "创建时间",
    dataIndex: "createTime",
    key: "createTime",
  },
];

export const formTab = (providers_level: any, cascaderProps: any) => [
  {
    label: "账号",
    name: "mobile",
    type: "input",
  },
  {
    label: "用户昵称",
    name: "nickName",
    type: "input",
    width: "280px",
  },
  {
    label: "推荐人手机号",
    name: "recommendMobile",
    type: "input",
    width: "280px",
  },
  {
    label: "团队属性",
    name: "teamAttribute",
    type: "input",
    width: "280px",
  },
  {
    label: "用户等级",
    name: "userLevel",
    type: "select",
    options: providers_level,
  },
  {
    label: "用户类型",
    name: "userType",
    type: "select",
    options: [
      {
        label: "管理",
        value: "0",
      },
      {
        label: "普通",
        value: "1",
      },
    ],
  },
  {
    label: "流水股东",
    name: "flowingShareholders",
    type: "select",
    options: flowingShareholders_options,
  },
  {
    label: "区域范围",
    name: "channelName",
    type: "cascader",
    params: {
      ...cascaderProps,
      onChange: (value: any, selectedOptions: any) => {
        console.log(value, selectedOptions);
      },
    },
  },
  {
    label: "时间范围",
    name: "rangePicker",
    type: "rangePicker",
    width: "380px",
  },
];

export const modalFormTab = (options: { label: string; value: string }[]) => [
  {
    label: "数额方式",
    name: "accountTrend",
    type: "select",
    labelCol1: { span: 0, offset: 1 },
    rules: [{ required: true, message: "请选择类型" }],
    options: [
      {
        label: "赚取",
        value: "1",
      },
      {
        label: "消耗/扣减",
        value: "2",
      },
    ],
  },
  {
    label: "添加类型",
    name: "accountType",
    type: "select",
    rules: [{ required: true, message: "请选择类型" }],
    labelCol1: { span: 0, offset: 1 },
    options,
  },
  {
    label: "数额",
    name: "amount",
    type: "input",
    rules: [
      { required: true, message: "请输入数额" },
      {
        pattern: /^-?\d+(\.\d{1,2})?$/,
        message: "请输入正确数额",
      },
    ],
  },
  {
    label: "备注",
    name: "remark",
    type: "textArea",
    params: {
      placeholder: "请输入备注",
      rows: 3,
      maxLength: 200,
      showCount: true,
    },
  },
];
